/**
 UNIFIED_DOMAIN_LOCALES: are locales which are either unified already.
 SUPPORTED_UNIFIED_DOMAIN_LOCALES: are locales which are being migrated to unified domain
*/
//DO NOT ADD NEW LOCALE HERE UNLESS THEY ARE RELEASED TO UNIFIED DOMAIN (i.e. COM DOMAIN) IN PRODUCTION
export const UNIFIED_DOMAIN_LOCALES = ['pl-pl', 'fi-fi', 'en', 'en-us', 'fr-fr', 'en-ie', 'es-es'];
export const shouldEnableUnifiedDomain = (locale) => {
    var _a, _b, _c, _d;
    if (UNIFIED_DOMAIN_LOCALES.includes(locale.toLowerCase()))
        return true;
    if (typeof window === 'undefined') {
        // rely on environment variable for ssg pages
        const supportedLocales = process.env.NEXT_PUBLIC_SUPPORTED_UNIFIED_DOMAIN_LOCALES ||
            process.env.REACT_APP_SUPPORTED_UNIFIED_DOMAIN_LOCALES ||
            '';
        return supportedLocales.toLowerCase().split(',').includes(locale.toLowerCase());
    }
    const isCOM = (_b = (_a = window.location) === null || _a === void 0 ? void 0 : _a.hostname) === null || _b === void 0 ? void 0 : _b.endsWith('.com');
    const localePath = (_d = (_c = window.location) === null || _c === void 0 ? void 0 : _c.pathname) === null || _d === void 0 ? void 0 : _d.split('/')[1];
    return isCOM && localePath.toLocaleLowerCase() === locale.toLowerCase();
};
export const shouldEnableIPP = (locale, category, IPP_ENABLED_LOCALES) => {
    const settings = IPP_ENABLED_LOCALES[locale];
    return settings ? settings[category] : false;
};
//# sourceMappingURL=utils.js.map